// @ts-check

import { getCompanyReportingDimensions } from '@/api/reportingDimensions'
import { HIDE_TITLE_ON_MOBILE, ROUTE_NAME } from '@/router/meta'
import { store } from '@/store'

/** @type {import('vue-router').NavigationGuard} */
async function beforeEnteringInvoicePage(to, from, next) {
  if (store.getters['products/vatClassesAreFetched'] === false) {
    await store.dispatch('products/fetchVatClasses')
  }

  getCompanyReportingDimensions.clear()

  next()
}

/** @type {import('vue-router').RouteRecordRaw} */
export const createInvoiceRoute = {
  path: '/invoice',
  name: 'new_invoice',
  component: () => import('@/views/InvoiceEdit.vue'),
  beforeEnter: beforeEnteringInvoicePage,
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'new_invoice',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const editInvoiceRoute = {
  path: '/invoice/:id',
  name: 'edit_invoice',
  component: () => import('@/views/InvoiceEdit.vue'),
  beforeEnter: beforeEnteringInvoicePage,
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'edit_invoice',
    [HIDE_TITLE_ON_MOBILE]: true
  }
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export const invoiceRoutes = [createInvoiceRoute, editInvoiceRoute]

export default invoiceRoutes
